export default __webpack_public_path__ + "static/media/hello.89f38f85.gif";